import { LANGUAGE, IS_EUROPE } from '../../config/region';

import aboutUs from './posts/about-us';
import cooperation from './posts/cooperation';
import novelCreationGuide from './posts/novel-creation-guide';
import lagerRassvet from './posts/lager-rassvet';
import alternativaCharacterAi from './posts/alternativa-character-ai';
import animeNovelsOnline2026 from './posts/anime-novels-online-2026';
import historyOfVisualNovels from './posts/history-of-visual-novels';
import romanticNovelsAi from './posts/romantic-novels-ai';
import aiNovelsHowItWorks from './posts/ai-novels-how-it-works';
import visualNovelsGuide from './posts/visual-novels-guide';
import visualNovelsOnlineFree from './posts/visual-novels-online-free';
import howToWriteVnScenario from './posts/how-to-write-vn-scenario';
import fantasyNovelsAi from './posts/fantasy-novels-ai';
import aiVsClassicNovels from './posts/ai-vs-classic-novels';
import vnGenresGuide from './posts/vn-genres-guide';
import aiChatsVsNovels from './posts/ai-chats-vs-novels';
import klubRomantikiVsAinovel from './posts/klub-romantiki-vs-ainovel';
import harryPotterInteractiveNovels from './posts/harry-potter-interactive-novels';
import middleEarthCallOfTheRing from './posts/middle-earth-call-of-the-ring';
import interviewAuri from './posts/interview-auri';
import academySilverThorn from './posts/academy-silver-thorn';

/*
 * The blog, resolved to one language.
 *
 * Each post lives in its own module holding every language it has been translated into, so all
 * versions of one article are edited side by side rather than scattered across seven parallel
 * files that silently drift apart.
 *
 * Slugs are shared across languages on purpose: /en/blog/how-to-write-vn-scenario and
 * /de/blog/how-to-write-vn-scenario are the same article, which is what makes the hreflang
 * alternates SeoHead emits correct by construction, and means a link shared between languages
 * always resolves. Localised slugs would buy a little keyword relevance in the URL and cost a
 * mapping table that has to be right in 42 directions.
 */
const ALL = [
  aboutUs,
  cooperation,
  novelCreationGuide,
  lagerRassvet,
  alternativaCharacterAi,
  animeNovelsOnline2026,
  historyOfVisualNovels,
  romanticNovelsAi,
  aiNovelsHowItWorks,
  visualNovelsGuide,
  visualNovelsOnlineFree,
  howToWriteVnScenario,
  fantasyNovelsAi,
  aiVsClassicNovels,
  vnGenresGuide,
  aiChatsVsNovels,
  klubRomantikiVsAinovel,
  harryPotterInteractiveNovels,
  middleEarthCallOfTheRing,
  interviewAuri,
  academySilverThorn,
];

/*
 * A post with no version in the chosen language falls back — to English in europe, to Russian in
 * russia. A reader finding one English article among German ones is a far smaller failure than a
 * blog whose contents silently change depending on which flag was picked.
 */
const pick = (post) => {
  const version = post[LANGUAGE]
    || (IS_EUROPE ? post.english : post.russian)
    || post.russian;
  return { slug: post.slug, datePublished: post.datePublished, dateModified: post.dateModified, ...version };
};

const posts = ALL.map(pick);

export default posts;
